import { useNavigate } from "react-router-dom";
import { _adr } from "../../address";
import { Roles } from "../../tools/services";

export const GlobalMenu = (nav, _currentUser = null) => {
	console.log(_currentUser);
	if (process.env.REACT_APP_MENU === "normal") {
		return [
			{
				key: "menu00",
				label: "داشبورد",
				icon: <i className="icon-dashboard" style={{ fontSize: "1rem !important" }}></i>,
				onClick: () => {
					nav(_adr.Root + _adr.Home);
				},
			},
			_currentUser?.roles?.includes(Roles.Delear_360_Customerservice) && {
				key: "menu360",
				label: "خدمات 360",
				icon: <i className="icon-service360"></i>,
				onClick: () => nav(_adr.Root + _adr.Services360.Index),
			},
			_currentUser?.roles?.includes(Roles.Dealer_SearchB2B_Subscription) && {
				key: "corporatesubscribersearch",
				label: "جستجو مشترکین حقوقی",
				icon: <i className="icon-service360"></i>,
				onClick: () => nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Search),
			},
			_currentUser?.roles?.includes(Roles.Dealer_Register_B2C_BankCard) && {
				key: "creditCard",
				label: "دریافت کارت بانکی ترکیه",
				icon: <i className="icon-service360"></i>,
				onClick: () => nav(_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.List),
			},
			_currentUser?.roles?.includes(
				Roles.Dealer_RegisterSim_B2C_Iranian,
				Roles.Dealer_RegisterSim_B2C_NonIranian,
				Roles.Dealer_RegisterSim_Report_One,
				Roles.Dealer_RegisterSim_Report_UploadingDoc,
			) && {
				key: "menu01",
				label: "فروش سیم‌کارت",
				icon: <i className="icon-simcard"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_B2C_Iranian) && {
						key: "menu01sub01",
						label: "ثبت‌نام سیم‌کارت حقیقی",
						onClick: () => {
							nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit);
						},
					},
					_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_B2C_NonIranian) && {
						key: "menu01sub03",
						label: "ثبت نام اتباع",
						onClick: () => {
							nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Kit);
						},
					},
					_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Report_UploadingDoc) && {
						key: "menu01sub04",
						label: "در انتظار آپلود مدارک",
						onClick: () => nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.List),
					},
				],
			},
			_currentUser?.roles?.includes(
				Roles.Dealer_ChangeOwner_B2C_Iranian,
				Roles.Dealer_ChangeOwner_Report_One,
				Roles.Dealer_ChangeOwner_Report_UploadingDoc,
			) && {
				key: "menu02",
				label: "تغییر مالکیت",
				icon: <i className="icon-change-owner"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_ChangeOwner_B2C_Iranian) && {
						key: "menu02sub01",
						label: "انتقال مالکیت",
						onClick: () =>
							nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.InformationSeller),
					},

					_currentUser?.roles?.includes(Roles.Dealer_ChangeOwner_Report_UploadingDoc) && {
						key: "menu02sub03",
						label: "درانتظار آپلود مدارک",
						onClick: () => nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Pending.Index + _adr.ChangeOwnerShip.Pending.List),
					},
				],
			},
			_currentUser?.roles?.includes(
				Roles.Dealer_SimSwap_B2C_Iranian,
				Roles.Dealer_SimSwap_B2B_Iranian,
				Roles.Dealer_SimSwap_Report_One,
				Roles.Dealer_SimSwap_Report_UploadingDoc,
			) && {
				key: "menu03",
				label: "تعویض سیم‌کارت",
				icon: <i className="icon-change-sim"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_SimSwap_B2C_Iranian) && {
						key: "menu03sub01",
						label: "تعویض سیم کارت",
						onClick: () => nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidMsisdn),
					},
					_currentUser?.roles?.includes(Roles.Dealer_SimSwap_Report_UploadingDoc) && {
						key: "menu03sub04",
						label: "در انتظار آپلود مدارک",
						onClick: () =>
							nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Pending.Index + _adr.SimCardReplacement.Pending.List),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas, Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc) && {
				key: "menu04",
				label: "کارتابل تحویل حضوری",
				icon: <i className="icon-airplane"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas) && {
						key: "menu04sub01",
						label: "کارتابل تحویل حضوری",
						onClick: () => nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Valid),
					},
					_currentUser?.roles?.includes(Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc) && {
						key: "menu04sub02",
						label: "در انتظار آپلود مدارک",
						onClick: () => nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Pending.Index + _adr.DeliveryArea.Pending.List),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.Dealer_Wallet_Management) && {
				key: "menu05",
				label: "مدیریت کیف پول",
				icon: <i className="icon-wallet"></i>,
				onClick: () => nav(_adr.Root + _adr.Wallet.Index + _adr.Wallet.WalletList),
			},
			_currentUser?.roles?.includes(Roles.Dealer_EPPurchase_B2C, Roles.Dealer_EPPurchase_ReportOne) && {
				key: "menu06",
				label: "فروش بسته",
				icon: <i className="icon-packages"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_EPPurchase_B2C) && {
						key: "menu06sub01",
						label: "فروش بسته",
						onClick: () => nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Valid),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.Dealer_DCPurchase_B2C, Roles.Dealer_DCPurchase_ReportOne) && {
				key: "menu07",
				label: "فروش شارژ",
				icon: <i className="icon-dc"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_DCPurchase_B2C) && {
						key: "menu07sub01",
						label: "فروش شارژ",
						onClick: () => nav(_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Charge),
					},
				],
			},
			(_currentUser?.roles?.includes(Roles.Dealer_RequsetKit) || _currentUser?.roles?.includes(Roles.Dealer_AssignKit)) && {
				key: "menuManageSimcard",
				label: <span className="menu-item-wrap-text">مدیریت کیت سیم‌کارت</span>,
				icon: <i className="icon-dc"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_RequsetKit) && {
						key: "newRequest",
						label: "درخواست",
						onClick: () => nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.NewRequest),
					},
					_currentUser?.roles?.includes(Roles.Dealer_RequsetKit) && {
						key: "dealerKitInventory",
						label: "موجودی کیت نماینده",
						onClick: () => nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.Inventory),
					},
					_currentUser?.roles?.includes(Roles.Dealer_AssignKit) && {
						key: "assignKitToDealer",
						label: "تخصیص کیت به نماینده",
						onClick: () => nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKit),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.Dealer_HotBill_Pay) && {
				key: "paybillRoot",
				label: "پرداخت صورت حساب",
				icon: <i className="icon-dc"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_HotBill_Pay) && {
						key: "paybillSub",
						label: "پرداخت صورت حساب",
						onClick: () => nav(_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Bill),
					},
				],
			},
			{
				key: "menu08",
				label: "مدیریت کاربران",
				icon: <i className="icon-user-managment"></i>,
			},
			{
				key: "menu09",
				label: "گزارشات",
				icon: <i className="icon-report"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Report_One) && {
						key: "menu09sub01",
						label: "گزارشات ثبت‌نام سیم‌کارت",
						onClick: () => nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Report.Index + _adr.SimCardPurchase.Report.List),
					},
					_currentUser?.roles?.includes(Roles.Dealer_ChangeOwner_Report_One) && {
						key: "menu09sub02",
						label: "گزارشات انتقال مالکیت سیم‌کارت",
						onClick: () => nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Report.Index + _adr.ChangeOwnerShip.Report.List),
					},
					_currentUser?.roles?.includes(Roles.Dealer_SimSwap_Report_One) && {
						key: "menu09sub03",
						label: "گزارشات تعویض سیم کارت",
						onClick: () =>
							nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Report.Index + _adr.SimCardReplacement.Report.List),
					},
					_currentUser?.roles?.includes(Roles.Dealer_EPPurchase_ReportOne) && {
						key: "menu09sub04",
						label: "گزارشات فروش بسته",
						onClick: () => nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Report.Index + _adr.EPPurchase.Report.List),
					},
					_currentUser?.roles?.includes(Roles.Dealer_DCPurchase_ReportOne) && {
						key: "menu09sub05",
						label: "گزارشات فروش شارژ",
						onClick: () => nav(_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Report.Index + _adr.DCPurchase.Report.List),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.CRM_RegisterSim_Catable_Post) && {
				key: "menu10",
				label: "کارتابل پست",
				icon: <i className="icon-postbox"></i>,
				onClick: () => nav(_adr.Root + _adr.CartablePost.Index),
			},
			_currentUser?.roles?.includes(Roles.Dealer_GroupActivation_Charge_API) && {
				key: "meunuBulk",
				label: "پردازش های گروهی",
				icon: <i className="icon-postbox"></i>,
				children: [
					{
						key: "bulkDC",
						label: "پردازش گروهی شارژ",
						onClick: () => nav(_adr.Root + _adr.Bulks.Index + _adr.Bulks.DCBulk),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.Dealer_DastaneMan, Roles.Dealer_AsanBimeh) && {
				key: "exteraLink",
				label: "خدمات سایر شرکت‌ها",
				icon: <i className="icon-postbox"></i>,
				children: [
					{
						key: "DastaneMan",
						label: "داستان من",
						onClick: () => window.open(`https://dastaneman.com/?token=${_currentUser?.id}&channel=APTEL`, "_blank"),
					},
					{
						key: "AsanBimeh",
						label: "آسان بیمه",
						onClick: () => window.open(`https://seller.asanbime.com/home?token=${_currentUser?.id}&channel=APTEL`, "_blank"),
					},
				],
			},
			// {

			//   key: "menuCreditCard",
			//   label: "دریافت کارت‌ بانکی",
			//   icon: <i className="icon-creditcard"></i>,
			//   onClick: () => {
			//     nav(_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.list);
			//   },
			// },
		];
	} else {
		return [
			{
				key: "menu00",
				label: "داشبورد",
				icon: <i className="icon-dashboard"></i>,
				onClick: () => {
					nav(_adr.Root + _adr.Home);
				},
			},
			_currentUser?.roles?.includes(Roles.Delear_360_Customerservice) && {
				key: "menu360",
				label: "خدمات 360",
				icon: <i className="icon-service360"></i>,
				onClick: () => nav(_adr.Root + _adr.Services360.Index),
			},
			_currentUser?.roles?.includes(Roles.Dealer_SearchB2B_Subscription) && {
				key: "corporatesubscribersearch",
				label: "جستجو مشترکین حقوقی",
				icon: <i className="icon-service360"></i>,
				onClick: () => nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Search),
			},
			_currentUser?.roles?.includes(Roles.Dealer_Register_B2C_BankCard) && {
				key: "creditCard",
				label: "دریافت کارت بانکی ترکیه",
				icon: <i className="icon-service360"></i>,
				onClick: () => nav(_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.List),
			},
			_currentUser?.roles?.includes(
				Roles.Dealer_RegisterSim_B2C_Iranian,
				Roles.Dealer_RegisterSim_B2C_NonIranian,
				Roles.Dealer_RegisterSim_Report_One,
				Roles.Dealer_RegisterSim_Report_UploadingDoc,
			) && {
				key: "menu01",
				label: "فروش سیم‌کارت",
				icon: <i className="icon-simcard"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_B2C_Iranian) && {
						key: "menu01sub01",
						label: "ثبت‌نام سیم‌کارت حقیقی",
						onClick: () => {
							nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit);
						},
					},
					_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_B2C_NonIranian) && {
						key: "menu01sub03",
						label: "ثبت نام اتباع",
						onClick: () => {
							nav(_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Kit);
						},
					},
					_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Report_UploadingDoc) && {
						key: "menu01sub04",
						label: "در انتظار آپلود مدارک",
						onClick: () => nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.List),
					},
				],
			},
			_currentUser?.roles?.includes(
				Roles.Dealer_ChangeOwner_B2C_Iranian,
				Roles.Dealer_ChangeOwner_Report_One,
				Roles.Dealer_ChangeOwner_Report_UploadingDoc,
			) && {
				key: "menu02",
				label: "تغییر مالکیت",
				icon: <i className="icon-change-owner"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_ChangeOwner_B2C_Iranian) && {
						key: "menu02sub01",
						label: "انتقال مالکیت",
						onClick: () =>
							nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.InformationSeller),
					},

					_currentUser?.roles?.includes(Roles.Dealer_ChangeOwner_Report_UploadingDoc) && {
						key: "menu02sub03",
						label: "درانتظار آپلود مدارک",
						onClick: () => nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Pending.Index + _adr.ChangeOwnerShip.Pending.List),
					},
				],
			},
			_currentUser?.roles?.includes(
				Roles.Dealer_SimSwap_B2C_Iranian,
				Roles.Dealer_SimSwap_B2B_Iranian,
				Roles.Dealer_SimSwap_Report_One,
				Roles.Dealer_SimSwap_Report_UploadingDoc,
			) && {
				key: "menu03",
				label: "تعویض سیم‌کارت",
				icon: <i className="icon-change-sim"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_SimSwap_B2C_Iranian) && {
						key: "menu03sub01",
						label: "تعویض سیم کارت",
						onClick: () => nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidMsisdn),
					},
					_currentUser?.roles?.includes(Roles.Dealer_SimSwap_Report_UploadingDoc) && {
						key: "menu03sub04",
						label: "در انتظار آپلود مدارک",
						onClick: () =>
							nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Pending.Index + _adr.SimCardReplacement.Pending.List),
					},
				],
			},
			_currentUser?.roles?.includes(
				Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas,
				Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc,
				Roles.Dealer_SimSwap_Can_PickupMethodOfReceipt,
			) && {
				key: "menu04",
				label: "کارتابل تحویل حضوری",
				icon: <i className="icon-airplane"></i>,
				children: [
					(_currentUser?.roles?.includes(Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas) ||
						_currentUser?.roles?.includes(Roles.Dealer_SimSwap_Can_PickupMethodOfReceipt)) && {
						key: "menu04sub01",
						label: "کارتابل تحویل حضوری",
						onClick: () => nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Valid),
					},
					(_currentUser?.roles?.includes(Roles.Dealer_SimSwap_B2C_Iranian_DeliveryAreas_UploadingDoc) ||
						_currentUser?.roles?.includes(Roles.Dealer_SimSwap_Can_PickupMethodOfReceipt)) && {
						key: "menu04sub02",
						label: "در انتظار آپلود مدارک",
						onClick: () => nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Pending.Index + _adr.DeliveryArea.Pending.List),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.Dealer_Wallet_Management) && {
				key: "menu05",
				label: "مدیریت کیف پول",
				icon: <i className="icon-wallet"></i>,
				onClick: () => nav(_adr.Root + _adr.Wallet.Index + _adr.Wallet.WalletList),
			},
			_currentUser?.roles?.includes(Roles.Dealer_EPPurchase_B2C, Roles.Dealer_EPPurchase_ReportOne) && {
				key: "menu06",
				label: "فروش بسته",
				icon: <i className="icon-packages"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_EPPurchase_B2C) && {
						key: "menu06sub01",
						label: "فروش بسته",
						onClick: () => nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Valid),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.Dealer_DCPurchase_B2C, Roles.Dealer_DCPurchase_ReportOne) && {
				key: "menu07",
				label: "فروش شارژ",
				icon: <i className="icon-dc"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_DCPurchase_B2C) && {
						key: "menu07sub01",
						label: "فروش شارژ",
						onClick: () => nav(_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Charge),
					},
				],
			},
			(_currentUser?.roles?.includes(Roles.Dealer_RequsetKit) || _currentUser?.roles?.includes(Roles.Dealer_AssignKit)) && {
				key: "menuManageSimcard",
				label: <span className="menu-item-wrap-text">مدیریت کیت سیم‌کارت</span>,
				icon: <i className="icon-dc"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_RequsetKit) && {
						key: "newRequest",
						label: "درخواست",
						onClick: () => nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.NewRequest),
					},
					_currentUser?.roles?.includes(Roles.Dealer_RequsetKit) && {
						key: "dealerKitInventory",
						label: "موجودی کیت نماینده",
						onClick: () => nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.Inventory),
					},
					_currentUser?.roles?.includes(Roles.Dealer_AssignKit) && {
						key: "assignKitToDealer",
						label: "تخصیص کیت به نماینده",
						onClick: () => nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKit),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.Dealer_HotBill_Pay) && {
				key: "paybillRoot",
				label: "پرداخت صورت حساب",
				icon: <i className="icon-dc"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_HotBill_Pay) && {
						key: "paybillSub",
						label: "پرداخت صورت حساب",
						onClick: () => nav(_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Bill),
					},
				],
			},
			// {
			//   key: "menu08",
			//   label: "مدیریت کاربران",
			//   icon: <i className="icon-user-managment"></i>,
			// },
			{
				key: "menu09",
				label: "گزارشات",
				icon: <i className="icon-report"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Report_One) && {
						key: "menu09sub01",
						label: "گزارشات ثبت‌نام سیم‌کارت",
						onClick: () => nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Report.Index + _adr.SimCardPurchase.Report.List),
					},
					_currentUser?.roles?.includes(Roles.Dealer_ChangeOwner_Report_One) && {
						key: "menu09sub02",
						label: "گزارشات انتقال مالکیت سیم‌کارت",
						onClick: () => nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.Report.Index + _adr.ChangeOwnerShip.Report.List),
					},
					_currentUser?.roles?.includes(Roles.Dealer_SimSwap_Report_One) && {
						key: "menu09sub03",
						label: "گزارشات تعویض سیم کارت",
						onClick: () =>
							nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Report.Index + _adr.SimCardReplacement.Report.List),
					},
					_currentUser?.roles?.includes(Roles.Dealer_EPPurchase_ReportOne) && {
						key: "menu09sub04",
						label: "گزارشات فروش بسته",
						onClick: () => nav(_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Report.Index + _adr.EPPurchase.Report.List),
					},
					_currentUser?.roles?.includes(Roles.Dealer_DCPurchase_ReportOne) && {
						key: "menu09sub05",
						label: "گزارشات فروش شارژ",
						onClick: () => nav(_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Report.Index + _adr.DCPurchase.Report.List),
					},
				],
			},
			_currentUser?.roles?.includes(Roles.CRM_RegisterSim_Catable_Post) && {
				key: "menu10",
				label: "کارتابل پست",
				icon: <i className="icon-postbox"></i>,
				onClick: () => nav(_adr.Root + _adr.CartablePost.Index),
			},
			_currentUser?.roles?.includes(Roles.Dealer_GroupActivation_Charge_API) && {
				key: "meunuBulk",
				label: "پردازش های گروهی",
				icon: <i className="icon-postbox"></i>,
				children: [
					{
						key: "bulkDC",
						label: "پردازش گروهی شارژ",
						onClick: () => nav(_adr.Root + _adr.Bulks.Index + _adr.Bulks.DCBulk),
					},
				],
			},
			(_currentUser?.roles?.includes(Roles.Dealer_DastaneMan) || _currentUser?.roles?.includes(Roles.Dealer_AsanBimeh)) && {
				key: "exteraLink",
				label: "خدمات سایر شرکت‌ها",
				icon: <i className="icon-postbox"></i>,
				children: [
					_currentUser?.roles?.includes(Roles.Dealer_DastaneMan) && {
						key: "DastaneMan",
						label: "داستان من",
						onClick: () => window.open(`https://dastaneman.com/Dealers/?token=${_currentUser?.id}&channel=APTEL`, "_blank"),
					},
					_currentUser?.roles?.includes(Roles.Dealer_AsanBimeh) && {
						key: "AsanBimeh",
						label: "آسان بیمه",
						onClick: () => window.open(`https://seller.asanbime.com/home?token=${_currentUser?.id}&channel=APTEL`, "_blank"),
					},
				],
			},
			// {
			//   key: "menuCreditCard",
			//   label: "دریافت کارت‌ بانکی",
			//   icon: <i className="icon-creditcard"></i>,
			//   onClick: () => {
			//     nav(_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.list);
			//   },
			// },
		];
	}
};
